import {FileService} from '../utils/file.service';

 export default function (value) {
  return FileService.getFileType(value);
};
